<section class="static-text">
  <div class="static-text--container">
    <div class="static-text--content">
      <div class="static-text--mission-box">
        <div class="mission--card">
          <p class="mission--card-headline">{{ missionHeadline }}</p>
          <div class="mission--card-pattern" aria-hidden="true"></div>
        </div>
      </div>

      <div class="static-text--description">
        <p class="description--text">{{ missionDescription }}</p>
      </div>
    </div>
  </div>
</section>
